import { useContext } from "react";

import { AsyncTaskContext } from "@/modern/components/async-tasks/context/AsyncTaskContext";
import { navigateToViewByType } from "@/modern/utils";
import { VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";
import BryntumContext from "@/react/context/bryntumContext";
import ExecutedIncentivesListModal from "@/react/components/swivuHome/ExecutedIncentivesListModal.jsx";

/**
 * EditorViews wrapper for the executed-incentives results dialog.
 * `record` is the openEditor payload: { incentiveRecords, taskIds }.
 */
export function ExecutedIncentivesEditor({ record, onClose }) {
  const { viewManager } = useContext(BryntumContext);
  const asyncTaskContext = useContext(AsyncTaskContext);
  const markSeen = asyncTaskContext?.markSeen;

  const incentiveRecords = record?.incentiveRecords ?? [];
  const taskIds = record?.taskIds ?? [];

  if (!incentiveRecords.length) {
    return null;
  }

  return (
    <ExecutedIncentivesListModal
      incentiveRecords={incentiveRecords}
      taskIds={taskIds}
      onShowPointsClicked={(incentiveIds) => {
        navigateToViewByType(viewManager, VIEW_TYPES.incentivePoints, "Points", {
          filters: { incentiveIds },
        });
      }}
      onDismiss={async (ids) => {
        if (!markSeen) return;
        await Promise.all(
          ids.map(async (taskId) => {
            try {
              await markSeen(taskId);
            } catch {
              // Task may already be marked seen.
            }
          }),
        );
      }}
      onClose={onClose}
    />
  );
}
